import { useState, useEffect } from 'react';
import { Row, Col, message, Form, Skeleton } from 'antd';
import { Card, Location } from 'soxo-bootstrap-core';
import PackageSelector from './components/package-selector';
import TimeSelector from './components/time-selector';
import BlockSlotDrawer from './components/block-slot-drawer';
// import BlockedButtoon from '/src/assets/icons/Blocked.png';
// import ProceedButton from '/src/assets/icons/Proceed.png';
import CustomAlert from '../../../../components/alert';
import { ActionButton } from './rendering-components';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { Appointments } from '../../../../models';
import './slot-blocking.scss';
// import { SLOT_STATUS } from './time-selector';
import { SLOT_STATUS } from './components/time-selector';
/**
 * SlotBlocking Component
 *
 * Main container component for appointment slot selection, blocking,
 * and proceeding workflows.
 */
export default function SlotBlocking() {
    const [form] = Form.useForm();
    const params = Location.search();
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertShownOnce, setAlertShownOnce] = useState(false);

    // for re-fetching after slot block/release
    const [shouldFetch, setShouldFetch] = useState(false);

    // const isBlockEnabled = selectedSlots?.length > 0;
    // disable Block button if slot(s) already blocked
    const isBlockEnabled =
        selectedSlots?.length > 0 && !selectedSlots.some((s) => s.item?.sub_mode === SLOT_STATUS.BLOCKED || s.sub_mode === SLOT_STATUS.BLOCKED);

    const isProceedEnabled = selectedSlots?.length === 1;

    const [btnLoading, setBtnLoading] = useState(false);

    const handleSlotSelect = (data) => {
        if (!data) {
            setSelectedDate(null);
            setSelectedSlots([]);
            return;
        }
        const { date, slot } = data;
        setSelectedDate(date);
        setSelectedSlots(Array.isArray(slot) ? slot : [slot]);

        // Show alert only once
        if (!alertShownOnce) {
            setShowAlert(true);
            setAlertShownOnce(true);
            // Auto close after 3 seconds
            setTimeout(() => setShowAlert(false), 3000);
        }
    };

    const onSlotConfirm = async () => {
        setBtnLoading(true);

        let sessionId = localStorage.getItem('SessionId');
        if (!sessionId) {
            sessionId = uuidv4();
            localStorage.setItem('SessionId', sessionId);
        }

        var params = Location.search();

        const selected = selectedSlots[0];

        if (selected) {
            const tokenNo = selected.token_no || selected.item?.token_no;
            const appTime = selected.as_starttime || selected.item?.as_starttime;
            const itmCode = selected.itm_code || selected.item?.itm_code || selectedPackage?.itm_code;
            const itm_slotdoctorptr = selected.itm_slotdoctorptr || selected.item?.itm_slotdoctorptr || selectedPackage?.itm_slotdoctorptr;

            const formBody = {
                session_id: sessionId,
                doctor_ptr: selectedPackage?.doctor_ptr,
                app_date: moment(selectedDate).format('YYYY-MM-DD'),
                token_number: tokenNo,
                app_time: appTime,
                source: 'DESK',
                sub_mode: selected.item?.sub_mode || 'DESK',
                package_type_value: itmCode,
            };

            const slotAvailable = await Appointments.slotBlock(formBody);
            setBtnLoading(false);

            if (slotAvailable.success) {
                const selected_time = moment(selectedDate).format('DD/MM/YYYY') + ' ' + appTime;
                const selected_date = moment(selectedDate).format('YYYY-MM-DD');

                let queryParam = {
                    ...params,
                    selected_time,
                    selected_date,
                    token_no: tokenNo,
                    token_no: tokenNo,
                    da_packagetypevalue: itmCode,
                    da_doctorptr: itm_slotdoctorptr,
                };

                Location.navigate({ url: `/new-registrations/guest`, queryParam });
            } else {
                message.error(slotAvailable.message);
            }
        } else {
            setBtnLoading(false);
            message.error('Please Select a Time Slot');
        }
    };

    /**
 *rescheduleAppointment()
---------------------------------------------
 1. Enable loading state
 2. Read selected slot details
 3. Build update parameters (doctor, date, time, token, session)
 4. Call API to reschedule appointment
 5. Disable loading state
 6. If success → show success + redirect to appointment page
 7. If failure → show error message
 */
    async function rescheduleAppointment() {
        setBtnLoading(true);
        const selected = selectedSlots[0];
        let updateParams = {
            da_doctorptr: selected.itm_slotdoctorptr || selected.item?.itm_slotdoctorptr || selectedPackage?.itm_slotdoctorptr,
            // da_date: moment(today).format('YYYY-MM-DD 00:00'),
            da_date: moment(selectedDate).format('YYYY-MM-DD'),
            da_aptime: selected.as_starttime || selected.item?.as_starttime,
            da_tokenno: selected.token_no || selected.item?.token_no,
            source: 'DESK',
            session_id: localStorage.SessionId,
        };
        let result = await Appointments.rescheduleAppointment(params.appointId, updateParams);
        setBtnLoading(false);

        if (result.success) {
            message.success('Appointment has been rescheduled ');
            Location.navigate({ url: `/appointment/${params.appointId}` });
        } else {
            message.error(result.message);
        }
    }

    //  Reset slots + date when package changes
    useEffect(() => {
        setSelectedSlots([]);
        setSelectedDate(null);
    }, [selectedPackage]);

    return (
        <>
            <Card className="">
                <div className="appointment-container">
                    <Row gutter={[20, 20]} className="equal-height-row">
                        {/* Package selection column */}

                        <Col xs={24} lg={8} className="package-column">
                            <PackageSelector
                                appointId={params?.appointId}
                                packageValue={params?.da_packagetypevalue}
                                selectedPackage={selectedPackage}
                                onSelect={setSelectedPackage}
                            />
                        </Col>

                        {/* Time slot selection column */}
                        <Col xs={24} lg={16}>
                            <div className="time-selector-component">
                            <TimeSelector
                                selectedDate={selectedDate}
                                selectedSlots={selectedSlots}
                                onSelect={handleSlotSelect}
                                packageData={selectedPackage}
                                shouldFetch={shouldFetch}
                                setShouldFetch={setShouldFetch}
                            />
                            </div>
                        </Col>
                    </Row>

                    {/* Action Buttons */}
                    <div className="action-buttons">
                        {/* Block button → opens BlockSlotDrawer */}
                        {params?.appointId ? (
                            <>
                                <ActionButton
                                    // icon={ProceedButton}
                                    label="Proceed"
                                    disabled={!isProceedEnabled}
                                    loading={btnLoading}
                                    onClick={rescheduleAppointment}
                                />
                            </>
                        ) : (
                            <>
                                <ActionButton
                                    // icon={BlockedButtoon}
                                    label="Reserve"
                                    disabled={!isBlockEnabled}
                                    onClick={() => setDrawerVisible(true)}
                                />

                                {/* Proceed button */}
                                <ActionButton
                                    // icon={ProceedButton}
                                    label="Proceed"
                                    disabled={!isProceedEnabled}
                                    loading={btnLoading}
                                    onClick={onSlotConfirm}
                                />
                            </>
                        )}
                    </div>

                    {/* Slot Blocking Drawer */}
                    <BlockSlotDrawer
                        open={drawerVisible}
                        // onClose={() => setDrawerVisible(false)}
                        onClose={() => {
                            form.resetFields();
                            setSelectedSlots([]);
                            setSelectedDate(null);
                            setDrawerVisible(false); // closes drawer
                        }}
                        selectedPackage={selectedPackage}
                        selectedSlots={selectedSlots}
                        setSelectedSlots={setSelectedSlots}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        form={form}
                        setShouldFetch={setShouldFetch}
                    />
                </div>
            </Card>

            {!params.appointId && showAlert && (
                <div
                    style={{
                        position: 'fixed',
                        top: '60px',
                        right: '20px',
                        maxWidth: '300px',
                        zIndex: 9999,
                    }}
                >
                    <CustomAlert
                        type="warning"
                        message="You can select multiple slots"
                        closable={true}
                        showIcon={false}
                        onClose={() => setShowAlert(false)}
                    />
                </div>
            )}
        </>
    );
}
